// Updated getFieldName function - matches field names stored in database
// Database stores: firstname, lastname, dateofbirth, currentpainlevel, etc. (all lowercase, no special chars)
export const getFieldName = (field, index) => {

  const {
    name: field_name_from_api,
    labelName: field_label,
    label: field_label_alt
  } = field || {};

  // First check if API provides a name - normalize to lowercase
  if (field_name_from_api) {
    // Normalize: remove special chars and convert to lowercase
    return field_name_from_api.toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  const finalFieldLabel = field_label || field_label_alt;

  // Map labels to database field names (all lowercase, no special chars)
  // These must match exactly what's stored in the database
  const labelMap = {
    'First Name': 'firstname',
    'Last Name': 'lastname',
    'Email': 'email',
    'Phone': 'phone',
    'Postal Code': 'postalcode',
    'Zip Code': 'postalcode',
    'T & C': 'tc',
    'Terms & Conditions': 'tc',
    'Date of Birth': 'dateofbirth',
    'Gender': 'gender',
    'Address': 'address',
    'Street': 'street',
    'City': 'city',
    'State': 'state',
    'Country': 'country',
    'CURRENT pain level:': 'currentpainlevel',
    'WORST pain level:': 'worstpainlevel',
    'BEST pain level:': 'bestpainlevel',
    'Current pain level': 'currentpainlevel',
    'Worst pain level': 'worstpainlevel',
    'Best pain level': 'bestpainlevel',
    'Image': 'image',
    'Radio': 'gender',
    'Text': 'text'
  };

  if (finalFieldLabel && labelMap[finalFieldLabel]) {
    return labelMap[finalFieldLabel];
  }

  if (finalFieldLabel) {
    // Generate name: lowercase, no special chars, no spaces
    const generatedName = finalFieldLabel
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
    return generatedName;
  }

  const fallbackName = `field_${index}`;
  return fallbackName;
};

